<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-dnb-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-dnb-' + id"
    :aria-controls="'collapse-dnb-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_DNB", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-dnb-' + id"
    :id="'collapse-dnb-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_H", 1) }}
              template(v-if="moreItems['dnbo'] && moreItems['dnbo']['H'] && moreItems['dnbo']['H'][6] && moreItems['dnbo']['H'][5] != 0 && moreItems['dnbo']['H'][5] != ''")
                OddsItem(:odds="moreItems['dnbo']['H']" idx=5 :typ="oddsType" dataType="3")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_A", 1) }}
              template(v-if="moreItems['dnbo'] && moreItems['dnbo']['A'] && moreItems['dnbo']['A'][6] && moreItems['dnbo']['A'][5] != 0 && moreItems['dnbo']['A'][5] != ''")
                OddsItem(:odds="moreItems['dnbo']['A']" idx=5 :typ="oddsType" dataType="3")
              template(v-else)
                OddsDisabled
        .normal(v-if="$helpers.objSize(moreItems['dnbho']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_H", 1) }}
              template(v-if="moreItems['dnbho'] && moreItems['dnbho']['H'] && moreItems['dnbho']['H'][6] && moreItems['dnbho']['H'][5] != 0 && moreItems['dnbho']['H'][5] != ''")
                OddsItem(:odds="moreItems['dnbho']['H']" idx=5 :typ="oddsType" dataType="3")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_A", 1) }}
              template(v-if="moreItems['dnbho'] && moreItems['dnbho']['A'] && moreItems['dnbho']['A'][6] && moreItems['dnbho']['A'][5] != 0 && moreItems['dnbho']['A'][5] != ''")
                OddsItem(:odds="moreItems['dnbho']['A']" idx=5 :typ="oddsType" dataType="3")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>